import { pageBreadcrumbStyles as styles } from "@insite/content-library/Components/PageBreadcrumbs";
import { css } from "styled-components";

styles.breadcrumbs = {
    mergeCss: true,
    css: css`
        padding-bottom: 15px;
        flex-wrap: wrap;
    `,
};
